module.exports = __webpack_public_path__ + "static/img/tianjinwei1.4e42a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tianjinwei1.png
// module id = JKuy
// module chunks = 1